import { autocompleteClasses } from '@mui/material/Autocomplete';

import {
  FIELD_BORDER_WIDTH_PX,
  FIELD_RADIUS_PX,
} from 'theme/components/field-geometry';
import type { ComponentOverrides } from 'theme/theme.types';
import { FONT_WEIGHT } from 'theme/typography';

export const SELECT_POPUP_OFFSET_PX = 2;

export const SELECT_MENU_PADDING_PX = 8;

export const SELECT_MENU_GAP_PX = 4;

export const SELECT_MENU_MAX_HEIGHT_PX = 300;

export const SELECT_OPTION_PADDING_PX = { x: 10, y: 8 } as const;

export const SELECT_LOADING_TEXT = 'Loading...';

const FORCED_COLORS = '@media (forced-colors: active)';
const FORCED_COLORS_OUTLINE_PX = 2;

const OPTION = `& .${autocompleteClasses.option}`;
const FOCUSED = `&.${autocompleteClasses.focused}`;
const SELECTED = '&[aria-selected="true"]';

const OPTION_PADDING = `${SELECT_OPTION_PADDING_PX.y}px ${SELECT_OPTION_PADDING_PX.x}px`;

export const MuiAutocomplete: ComponentOverrides['MuiAutocomplete'] = {
  defaultProps: {
    autoHighlight: true,
    loadingText: SELECT_LOADING_TEXT,
    slotProps: {
      popper: {
        modifiers: [
          { name: 'offset', options: { offset: [0, SELECT_POPUP_OFFSET_PX] } },
        ],
      },
    },
  },
  styleOverrides: {
    clearIndicator: { visibility: 'visible' },
    paper: ({ theme }) => ({
      padding: SELECT_MENU_PADDING_PX,
      border: `${FIELD_BORDER_WIDTH_PX}px solid ${theme.palette.border.tertiary}`,
      borderRadius: FIELD_RADIUS_PX,
      boxShadow: 'none',
      color: theme.palette.secondary.main,
    }),
    listbox: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: SELECT_MENU_GAP_PX,
      padding: 0,
      maxHeight: SELECT_MENU_MAX_HEIGHT_PX,
      [OPTION]: {
        flexShrink: 0,
        minHeight: 'auto',
        padding: OPTION_PADDING,
        borderRadius: FIELD_RADIUS_PX,
        color: theme.palette.secondary.main,
        overflowWrap: 'anywhere',
        [FOCUSED]: { backgroundColor: theme.palette.action.hover },
        [SELECTED]: {
          backgroundColor: theme.palette.action.selected,
          fontWeight: FONT_WEIGHT.semiBold,
          [FOCUSED]: { backgroundColor: theme.palette.action.selected },
        },
        [FORCED_COLORS]: {
          [FOCUSED]: {
            outline: `${FORCED_COLORS_OUTLINE_PX}px solid Highlight`,
            outlineOffset: -FORCED_COLORS_OUTLINE_PX,
          },
        },
      },
    }),
    noOptions: ({ theme }) => ({
      padding: OPTION_PADDING,
      color: theme.palette.text.secondary,
      textAlign: 'center',
    }),
    loading: ({ theme }) => ({
      padding: OPTION_PADDING,
      color: theme.palette.text.secondary,
      textAlign: 'center',
    }),
  },
};
